import { getNewAxisEdition, listNewAxisEditions } from "@/api/surveyTaxonomy.service";
import { useQuery } from "./useApi";

type UseNewAxisEditionsOptions = {
  enabled?: boolean;
};

export function useNewAxisEditions(options?: UseNewAxisEditionsOptions) {
  const enabled = options?.enabled ?? true;
  return useQuery(() => (enabled ? listNewAxisEditions() : Promise.resolve(null)), [enabled]);
}

export function useNewAxisEdition(editionId: string | null | undefined) {
  return useQuery(
    () => (editionId ? getNewAxisEdition(editionId) : Promise.resolve(null)),
    [editionId],
  );
}
